import React, {useState} from 'react';
import {
    Button,
    Popup,
    CardContent
} from '@chatui/core';
import Calendar from "../calendar";

function StoreStatus(props) {

	const {
		title= "Set Store Status",
		defaultText = "Please choose the dates.",
		value,
		setValue,
		language,
		editableRange=8,
		height=60,
		optionList=["open", "close", "renovation", "cancel"],
	} = props;

    const [open, setOpen] = useState(false);

	const renderSelectedDates = () => {
		if (value!==undefined && Object.keys(value).length>0){
			return (
				Object.keys(value).map((date, index)=>(
					<div key={index} className={"date-status-item"}>
						<span>{date} -- </span>
						<span>{optionList[value[date]]}</span>
					</div>
				))
			)
		}
		return <p>{defaultText}</p>
	}

    return (
        <>
			{renderSelectedDates()}
			<Popup
				title={title}
				active={open}
				onClose={()=>setOpen(false)}
				height={height}
			>
				<CardContent>
					<Calendar
						value={value}
						setValue={setValue}
						editableRange={editableRange}
						language={language}
						optionList={optionList}
					></Calendar>
				</CardContent>
			</Popup>
			<Button onClick={()=>setOpen(true)}>Set</Button>
        </>
    );
}

export default StoreStatus;